// Черновите на „Доставка" на началния екран и на таблото — общото
// `components/drafts/useHomeDrafts` с думите и картата на доставката: моята
// (от сървъра, а до BE без черновите — локалната в този браузър, с доставчика
// по името му) и тези на колегите; заета → „Поеми редакцията".
import { useSuppliers } from "../../../../../hooks/useInventory";
import { useHomeDrafts } from "../../../components/drafts/useHomeDrafts";
import { DRAFT_TEXTS } from "../../../components/drafts/draftTexts";
import { DELIVERY_DRAFT_STORE, localDeliveryDraftSummary } from "../deliveryWorksheetShared";

const NEW_PATH = "/inventory/delivery/new";

export const useDeliveryHomeDrafts = () => {
  const { data: suppliers = [] } = useSuppliers();
  return useHomeDrafts({
    type: "delivery",
    newPath: NEW_PATH,
    local: DELIVERY_DRAFT_STORE,
    localSummary: (draft) =>
      localDeliveryDraftSummary(draft, (supplierId) => suppliers.find((s) => s.id === supplierId)?.name ?? null),
    texts: DRAFT_TEXTS.delivery,
  });
};
